import session from '@api/session'
import { APIEndpoint } from '@api/_version'

export default {
  getAvailablePlans() {
    return session.get(APIEndpoint + '/api/payment-plans')
  },
  getPlanLimits(payload) {
    const params = {}
    if (payload) {
      params[payload] = true
    }

    return session.get(APIEndpoint + '/api/plan-limits-stats',
      { params: params })
  },
  getProrationAmount(payload) {
    return session.get(APIEndpoint + '/api/payment-plans/proration',
      { params: payload })
  },
}
